export default __webpack_public_path__ + "static/media/splashLeft.ad0e2a51.svg";